export const URL_PATTERN =
  /^(http(s)?:\/\/)?[\w.-]+\.\w+(\.[a-z]+)*(:\d{1,5})?(\/\S*)?$/;
